const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * "Oct 27", or "Feb 16, 2027" outside the current year — the way the prototype
 * writes a trait's dates. `null` for a missing or unreadable date.
 */
export const formatTraitDate = (iso, language = 'en', now = new Date()) => {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  const options =
    date.getFullYear() === now.getFullYear()
      ? { month: 'short', day: 'numeric' }
      : { month: 'short', day: 'numeric', year: 'numeric' };
  return date.toLocaleDateString(language, options);
};

/** "Sep 2, 2026" — always with the year, as Drive and Sandbox write a date. `null` for a missing or unreadable date. */
export const formatDateWithYear = (iso, language = 'en') => {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(language, { month: 'short', day: 'numeric', year: 'numeric' });
};

/** Whole days from `now` until `iso`, rounded up; negative once it has passed. */
export const daysUntil = (iso, now = new Date()) => {
  if (!iso) return null;
  const time = new Date(iso).getTime();
  if (Number.isNaN(time)) return null;
  return Math.ceil((time - now.getTime()) / DAY_MS);
};

/**
 * How much of a trait's validity is LEFT, 0–100: full when it was just learned,
 * empty when it expires. `null` without both ends.
 */
export const validityLeftPercent = (sinceIso, expiresIso, now = new Date()) => {
  if (!sinceIso || !expiresIso) return null;
  const since = new Date(sinceIso).getTime();
  const expires = new Date(expiresIso).getTime();
  if (Number.isNaN(since) || Number.isNaN(expires) || expires <= since) return null;
  const left = (expires - now.getTime()) / (expires - since);
  return Math.round(Math.min(1, Math.max(0, left)) * 100);
};
